<template>
    <div class="main-container page__forgetPassword">
        <div class="container__alert">
            <transition name="alert--animation">
                <div class="alert alert--error alert__errorConnexion" v-if="errorModal">
                    <div class="alert__header">
                        <div class="alert__title">
                            <p>{{translationArray.time_exceeded}}</p>
                        </div>
                        <hr>
                    </div>

                    <div class="alert__body">
                        <div class="alert__image">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.340562 19.6125C-0.425702 18.9151 0.340562 17.8689 0.340562 17.8689L8.3095 9.88624L0.512983 2.00191C0.512983 2.00191 -0.360283 0.994184 0.512983 0.258302C1.20265 -0.322869 2.06476 0.258287 2.06476 0.258287L9.99612 8.19672L17.7551 0.43265C17.7551 0.43265 18.7896 -0.43915 19.6517 0.43265C20.3414 1.13006 19.6517 2.00191 19.6517 2.00191L11.6341 9.76105L19.6517 17.8689C19.6517 17.8689 20.4354 18.7407 19.6517 19.6125C18.868 20.4843 17.7551 19.6125 17.7551 19.6125L9.8237 11.5919L1.89235 19.6125C1.89235 19.6125 1.10683 20.31 0.340562 19.6125Z" fill="white" fill-opacity="0.9"/>
                            </svg>
                        </div>
                        <div class="alert__description">
                            <p v-if="delayExpired">{{translationArray.link_expired}}</p>
                            <p v-if="wrongPassword">{{translationArray.unmatch_password}}</p>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div class="alert alert--information alert__askNFC" v-if="newPassword">
            <div class="alert__header">
                <div class="alert__title">
                    <p>{{translationArray.new_password}}</p>
                </div>
                <hr>
            </div>

            <div class="alert__body">
                <div class="alert__image">
                    <svg width="49" height="46" viewBox="0 0 49 46" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.02734 20.5699L20.5444 32.0869L47.4692 5.16211" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M38.2745 6.35135C34.4179 3.01696 29.3908 1 23.8926 1C11.7423 1 1.89258 10.8497 1.89258 23C1.89258 35.1503 11.7423 45 23.8926 45C36.0428 45 45.8926 35.1503 45.8926 23C45.8926 20.4957 45.4741 18.0891 44.7034 15.8464" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </div>
                <div class="alert__description">
                    <p>{{translationArray.password_update}}</p>
                </div>
            </div>
        </div>
        <header class="headerBlue">
            <div class="containerTitle">
                <h1>{{translationArray.password}}</h1>
                <p><span class="containerTitle__subtitle">{{translationArray.reinit_password}}</span></p>
            </div>

            <div class="containerPartner" v-bind:class="{ 'smallContainer': isSmallDesktop }">
                <div class=" partnerBox partnerBox__Right">
                    <img src="../../static/img/senzu.png" alt="">
                </div>
            </div>
            <div class="containerDescription">
                <p class="information__title__computer">{{translationArray.reinit_password}}</p>
                <p>{{translationArray.enter_new_password}}</p>
            </div>
        </header>
        <section class="body">
            <form class="roleForm" method="POST" @submit="validateForm">
                <p class="form__title" >{{translationArray.new_password_short}}</p>
                <fieldset class="formRow">
                    <legend>{{translationArray.new_password_short}}</legend>
                    <input type="password" v-model="firstPassword">
                </fieldset>
                <fieldset class="formRow">
                    <legend for="">{{translationArray.repeat_password}}</legend>
                    <input type="password" v-model="secondPassword">
                </fieldset>
                <div class="formRow">
                    <input class="submit" type="submit" value="Valider">
                </div>
            </form>        
        </section>
        <footer>
            <p>{{translationArray.more_on}}<a href="#" class="link_confidentiality">{{translationArray.privacy_rules}}</a></p>
        </footer>
    </div>
</template>

<script>
    import {translate} from '../../static/js/translate';

    export default {
        name: 'NewPassword',
        mounted() {
            this.translationArray = translate(navigator.language.substr(0, 2));

            let clientId = typeof(this.$route.query.client_id) !== "undefined" ? this.$route.query.client_id : null;
            if(clientId <= 8 || typeof(clientId) == 'undefined') {
                this.isSenzuApp = true;
            }

            window.addEventListener("resize", this.handleResize);
            this.handleResize();

            document.title = "Senzu | Mot de passe oublié";
        },
        data () {
            return {
                users: null,
                isSenzuApp: false,
                firstPassword: null,
                secondPassword: null,
                isDesktop: false,
                isMobile: true,
                newPassword: false,
                errorModal: false,
                delayExpired: false,
                wrongPassword: false,
                translationArray: {},
                csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        watch: {
            errorModal: function(value) {
                let _this = this;
                var timestamp = Date.now();
                window[timestamp] = setInterval(function() {
                    _this.errorModal = false;
                    _this.delayExpired = false;
                    _this.wrongPassword = false;
                    clearInterval(window[timestamp]);
                }, 5400);
            }
        },
        methods: {
            handleResize: function() {
                if(window.innerWidth <= 1120) {
                    this.isMobile = true;
                    this.isDesktop = false;
                } else {
                    this.isMobile = false;
                    this.isDesktop = true;
                }
            },
            validateForm: function(e) {
                e.preventDefault();
                const data = {first_password: this.firstPassword, second_password: this.secondPassword};
                if(this.firstPassword.length >= 6 && this.secondPassword.length >= 6 && this.firstPassword === this.secondPassword) {
                    let params = "?id=" + this.$route.query.id + "&timestamp=" + this.$route.query.timestamp + "&hash=" + this.$route.query.hash;

                    fetch(`${this.$origin}/new-password${params}`, {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                            'CSRF-Token': this.csrfToken
                        },
                        body: JSON.stringify(data)
                    }).then(result => result.json())
                    .then(data => {
                        if(data.error === 200) {
                            this.newPassword = true;
                        } else if(data.error === 463) {
                            this.errorModal = true;
                            this.delayExpired = true;
                        }
                    });
                } else {
                    this.errorModal = true;
                    this.wrongPassword = true;
                }

            }
        }
    }
</script>
        



// WEBPACK FOOTER //
// src/components/NewPassword.vue